<template>
	<div class="header">

    <div class="clear h146 pos-relative">
  
      <div class="h146 overflow-hidden pos-abs pos-c-t">
        <img class="w100p pos-abs pos-c-t"
             :src="publicPath + 'static/images/home/banner_01.jpg'"
             alt="logo">
        
        
      </div>
      
      <div class="h63 pos-abs pos-c l100 r100">
        <!-- logo begin -->
        <div class="fl w180 h100p pos-relative z10 logo-box">
          <img class="max-h100p pos-abs pos-c-l"
               :src="publicPath + 'static/images/common/logo_white.png'"
               alt="logo">
        </div>
        <!-- logo end -->
  
        <div class="fr h46 pos-relative z10">
          <!-- menu begin -->
          <div class="main-menu">
            <div class="clear main-menu-list">
              <div @click.stop="goToPage(item)"
                   class="fl main-menu-list-item"
                   :class="[{'is-active': item.routerName === 'home'}]"
                   v-for="(item, index) in $store.state.mainMenu">
                <div class="main-menu-list-item-text">
                  <div class="f18 h30 lh30 zh">{{ item.name[0] }}</div>
                  <div class="en">
                    <img :src="item.icon_img" alt="">
                  </div>
                </div>

                <div class="menu-child-list-lv1" v-if="item.children && item.children.length > 0">
                  <div @click.stop="goToPage(item1)" class="menu-child-list-lv1-item" v-for="(item1, index1) in item.children">

                    <div class="menu-child-list-lv2-item-text">
                      {{ item1.name }}
                    </div>

                    <div class="menu-child-list-lv2" v-if="item1.children && item1.children.length > 0">
                      <div @click.stop="goToPage(item2)" class="menu-child-list-lv2-item" v-for="(item2, index2) in item1.children">
                        <div class="menu-child-list-lv3-item-text">
                          {{ item2.name }}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- menu end -->
        </div>
      </div>
      
    </div>

    
  </div>
</template>

<script>
	export default {
		name: "Header",

    data() {
		  return {
		    menuBgImg: '',
		    
        menu: [
				  { id: 1, icon_img: '/static/images/common/menu_icons/icon_home.png', name: ['首页', 'HOME'], routerName: 'home' },
				  { id: 2, icon_img: 'dfgdfgf', name: ['公司简介1', 'COMPANY'], routerName: 'company' },
				  { id: 3, icon_img: '', name: ['业务领域', 'BUSINESS'], routerName: 'business' },
				  { id: 4, icon_img: '', name: ['服务目标和内容', 'SERVICE OBJECTIVES'], routerName: 'service-objectives' },
				  { id: 5, icon_img: '', name: ['服务网络', 'SERVICE NETWORK'], routerName: 'service network' },
				  { id: 6, icon_img: '', name: ['信息披露', 'INFORMATION'], routerName: 'information' },
				  // { id: 7, icon_img: '', name: ['热销产品', 'HOT PRODUCT'], routerName: 'hot-product' },
				  { id: 8, icon_img: '', name: ['公告发布', 'ANNOUNCEMENT'], routerName: 'announcement' },
				  { id: 9, icon_img: '', name: ['联系我们', 'CONTACT US'], routerName: 'contact-us' },
			  ],
      }
    },

    methods: {
      isActive(menuName) {

        // 首页
        if (menuName === 'home') {
          return true
        }

        // 公司简介
        else if (menuName === 'company' && ( this.$route.name === 'company')) {
          return true
        }

        // 服务目标和内容
        else if (menuName === 'service-objectives' && ( this.$route.name === 'service-contents')) {
          return true
        }

        return false
      },

      // 主菜单跳转
      goToPage(item) {
        if (item.type === 'link' && this.$route.name !== item.routerName) {
          this.$router.push({
            name: item.routerName
          })
        }
      }
    },
  }
</script>
